export default {
    botao_restaurar: 'Restaurar Padrão de Cards',
    little_cards: {
        equipamentos_total: 'Total de Equipamentos',
        equipamentos_ativos: 'Equipamentos Ativos',
        equipamentos_inativos: 'Equipamentos Inativos',
        resultados_hora: 'Resultados / Hora'
    },
    cards: {
        minimizar: 'Minimizar Card',
        maximizar: 'Maximizar Card',
        fechar: 'Fechar Card',
        equipment: 'Equipamentos',
        performance: 'Desempenho (Resultados/Hora)',
        horas_atras: 'Horas atrás',
        qualityControl: 'Validação/Controle de Qualidade',
        triggers: 'Triggers',
        results: 'Últimos Resultados',
        equipmentLogs: 'Erros/Logs dos Equipamentos',
        filtrar: 'Filtrar'
    },
    widgets: {
        QualityControl: {
            codigo_exame: 'Código do Exame'
        },
        LatestResult: {
            codigo_exame: 'Código do Exame',
            columns: {
                vns_equipamento: 'VNS/Equipamento',
                recipiente: 'Recipiente',
                paciente: 'Paciente',
                data_hora: 'Data/Hora',
                status: 'Status',
                liberado: 'Liberado',
                alerta: 'Alerta',
                bloqueado: 'Bloqueado',
                exame: 'Exame'
            },
            aviso_processamento: 'Ao liberar o exame será processado!',
            tem_certeza: 'Você tem certeza?',
            exame_liberado: 'Exame liberado!',
            sucesso: 'Sucesso'
        },
        TriggerWidget: {
            editar_trigger: 'Editar Trigger',
            nome: 'Nome',
            regra: 'Regra',
            acao: 'Ação',
            editar: 'Editar'
        }
    },
    tour: {
        buttons: {
            pular_tour: 'Pular Tour',
            voltar: 'Voltar',
            proximo: 'Próximo',
            finalizar: 'Finalizar',
        },
        descricao: {
            equipamentos_total: 'Exibe o total de vns cadastrado!',
            equipamentos_ativos: 'Exibe a quantidade de vns ativos no momento!',
            equipamentos_inativos: 'Exibe a quantidade de vns inativos no momento!',
            resultados_hora: 'Exibe a quantidade de exames realizados no período de 1 hora',
            equipment: 'Apresenta detalhes operacionais dos equipamentos gerenciados, dentre eles: Nome, Status, Tempo de atividade/inatividade',
            performance: 'Apresenta o volume de exames que estão sendo processado por equipamento mostrando sua evolução de uso.',
            qualityControl: 'Apresenta os valores obtidos dos resultados dos teste de controle de qualidade aplicados aos equipamentos gerenciados.',
            triggers: 'Exibe as Triggers referente a regras de liberação, bloqueio, alerta e etc.',
            results: 'Apresenta os resultados recebidos sendo eles por data, hora, ID do recipiente, status e consulta geral.',
            equipmentLogs: 'Monitore os erros/flags/status emitidos pelos equipamentos.'
        }
    },
    liberar_exame: {
        deseja_desbloquear: 'Deseja desbloquear ?',
        desbloquear: 'Desbloquear',
        sim: 'Sim',
        nao: 'Não',
        fechar: 'Fechar'
    }
}
